export default __webpack_public_path__ + "static/media/CANCIONES_DISCO_01.ed993ced.png";